"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReserveParser = exports.isReserve = exports.ReserveLayout = void 0;
const BufferLayout = __importStar(require("buffer-layout"));
const Layout = __importStar(require("../../utils/layout"));
const lastUpdate_1 = require("./lastUpdate");
exports.ReserveLayout = BufferLayout.struct([
    BufferLayout.u8('version'),
    lastUpdate_1.LastUpdateLayout,
    Layout.publicKey('lendingMarket'),
    BufferLayout.struct([
        Layout.publicKey('mintPubkey'),
        BufferLayout.u8('mintDecimals'),
        Layout.publicKey('supplyPubkey'),
        Layout.publicKey('feeReceiver'),
        BufferLayout.u8("usePythOracle"),
        Layout.publicKey('params_1'),
        Layout.publicKey("params_2"),
        Layout.uint64('availableAmount'),
        Layout.uint128('borrowedAmountWads'),
        Layout.uint128('cumulativeBorrowRateWads'),
        Layout.uint128('marketPrice'),
        Layout.uint128('ownerUnclaimed'),
    ], 'liquidity'),
    BufferLayout.struct([
        Layout.publicKey('mintPubkey'),
        Layout.uint64('mintTotalSupply'),
        Layout.publicKey('supplyPubkey'),
    ], 'collateral'),
    BufferLayout.struct([
        BufferLayout.u8('optimalUtilizationRate'),
        BufferLayout.u8('loanToValueRatio'),
        BufferLayout.u8('liquidationBonus'),
        BufferLayout.u8('liquidationThreshold'),
        BufferLayout.u8('minBorrowRate'),
        BufferLayout.u8('optimalBorrowRate'),
        BufferLayout.u8('maxBorrowRate'),
        BufferLayout.struct(
        // TODO: fix flash loan fee wad
        [
            Layout.uint64('borrowFeeWad'),
            Layout.uint64('borrowInterestFeeWad'),
            Layout.uint64("flashLoanFeeWad"),
            BufferLayout.u8('hostFeePercentage'),
            BufferLayout.u8('hostFeeReceiverCount'),
            BufferLayout.blob(32 * 5, 'hostFeeReceivers'),
        ], 'fees'),
        BufferLayout.u8("depositPaused"),
        BufferLayout.u8("borrowPaused"),
        BufferLayout.u8("liquidationPaused"),
    ], 'config'),
    BufferLayout.struct([
        Layout.publicKey("unCollSupply"),
        Layout.uint128('lTokenMiningIndex'),
        Layout.uint128('borrowMiningIndex'),
        Layout.uint64("totalMiningSpeed"),
        Layout.uint64("kinkUtilRate"),
    ], 'bonus'),
    BufferLayout.u8("reentry"),
    Layout.uint64("depositLimit"),
    BufferLayout.u8("isLP"),
    BufferLayout.blob(239, 'padding'),
]);
const isReserve = (info) => {
    return info.data.length === exports.ReserveLayout.span;
};
exports.isReserve = isReserve;
const ReserveParser = (pubkey, info) => {
    if (info == null) {
        throw new Error("Info can not be null");
    }
    const buffer = Buffer.from(info.data);
    const reserve = exports.ReserveLayout.decode(buffer);
    if (reserve.lastUpdate.slot.isZero()) {
        throw new Error("reserve.lastUpdate.slot.isZero()");
    }
    const details = {
        pubkey,
        account: Object.assign({}, info),
        info: reserve,
    };
    return details;
};
exports.ReserveParser = ReserveParser;
